/**
 * @file
 * Custom JS behaviour for products menu.
 */

(function ($) {

  Drupal.behaviors.products = {
    attach: function (context, settings) {

      // Menu products lines.
      once('initialized', '#block-prodotti', context).forEach(($nav_prodotti) => {
        //var $nav_prodotti = $('#block-prodotti');
        var $blocks_menu_product_lines = $('.block-menu-product-lines', context);

        // Mouse hover.
        $('a', $nav_prodotti).each(function (index) {

          $(this).click(function (event) {
            event.preventDefault();
          });

          $(this).mouseover(function () {
            if (!$blocks_menu_product_lines.eq(index).hasClass('active')) {
              $blocks_menu_product_lines.removeClass('active');
              $blocks_menu_product_lines.eq(index).addClass('active');
              var tid = $(this).parent().attr('data-id');
              getProdLineInfo(tid);
            }
          });
        });

        // Close menu.
        $('.header-bottom').mouseleave(function () {
          $blocks_menu_product_lines.removeClass('active');
        });

        // Call info from product line.
        var timer;
        $('#menu-product-lines > .item-list a').on({
          'mouseover': function () {
            var tid = $(this).attr('data-id');
            timer = setTimeout(function () {
              getProdLineInfo(tid);
            }, 200);
          },
          'mouseout': function () {
            clearTimeout(timer);
          },
        });

        // Get info prod line.
        function getProdLineInfo(tid) {
          $.ajax({
            url: '/ajax/line/' + tid,
            data: {
              format: 'json',
            },
            dataType: 'json',
            error: function () {
            },
            success: function (result) {
              var title = result.data.title;
              var description = result.data.text;
              var image = result.data.image;
              $('.product_line_image').attr('src', image);
              $('.product_line_title').text(title);
              $('.product_line_text').text(description);
              $('.product_line_link').show().attr('href', '/search-products?f[0]=product_lines:' + tid);
            },
          });
        }
      });
    },
  };
})(jQuery);
